import { TTP_BILLTOBOX_URL } from "Config";

const initialState = {
  uploading: false,
  uploaded: false,
  items: [],
  url: "",
  error: null,
  billtobox: {
    url: null
  }
};
export const wheretobillReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_UPLOAD": {
      return { ...state, items: state.items.concat(action.items) };
    }
    case "SET_UPLOADS": {
      return { ...state, items: action.items };
    }
    case "INIT_UPLOADS": {
      const help = { ...state.billtobox };
      return { ...initialState, billtobox: { ...help } };
    }
    case `SAVE_UPLOADS_PENDING`: {
      return { ...state, uploaded: false, uploading: true };
    }
    case `SAVE_UPLOADS_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        uploading: false,
        uploaded: true,
        error: null,
        items: [...state.items, data],
        nbResult: nbResult
      };
    }
    case `SAVE_UPLOADS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        uploading: false,
        error,
        items: [],
        nbResult: 0
      };
    }
    case `SEND_URL_PENDING`: {
      return { ...state, uploaded: false, uploading: true };
    }
    case `SEND_URL_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        uploading: false,
        uploaded: true,
        error: null,
        url: data,
        nbResult: nbResult
      };
    }
    case `SEND_URL_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        uploading: false,
        error,
        url: "",
        nbResult: 0
      };
    }
    case "FETCH_BILLTOBOX_URL_FULFILLED": {
      const { data } = action.payload;
      const url =
        data && data.token
          ? `${TTP_BILLTOBOX_URL}/login2/users/sign_in?partnerToken=${
              data.token
            }&partnerId=A1zreBrY`
          : TTP_BILLTOBOX_URL;
      return {
        ...state,
        billtobox: {
          ...state.billtobox,
          url
        }
      };
    }
    case "FETCH_BILLTOBOX_URL_REJECTED": {
      return {
        ...state,
        billtobox: { ...state.billtobox, url: TTP_BILLTOBOX_URL }
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/wheretobill.js